import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "../../../../../../../components/ui/common/table";
import { FacilitySourceTableColumn, FacilitySourceTableRow } from "../externalStorageFacility.types";

interface FacilityViewSourceTableProps {
  title: string;
  columns: FacilitySourceTableColumn[];
  rows: FacilitySourceTableRow[];
}

const FacilityViewSourceTable = ({ title, columns, rows }: FacilityViewSourceTableProps) => {
  if (!rows.length) {
    return null;
  }

  return (
    <div className="tw-space-y-3">
      <p className="tw-text-sm tw-font-semibold tw-text-foreground">{title}</p>
      <div className="tw-rounded-lg tw-border tw-border-border tw-overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Year</TableHead>
              {columns.map(column => (
                <TableHead key={column.key}>{column.header}</TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.id}>
                {row.yearRowSpan ? (
                  <TableCell rowSpan={row.yearRowSpan} className="tw-align-top">
                    {row.year}
                  </TableCell>
                ) : null}
                {row.cells.map((cell, index) => (
                  <TableCell key={`${row.id}-${index}`}>{cell}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default FacilityViewSourceTable;
